export enum TextTransform {
  Capitalize = 'capitalize',
  Inherit = 'inherit',
  Initial = 'initial',
  Lowercase = 'lowercase',
  None = 'none',
  Revert = 'revert',
  Unset = 'unset',
  Uppercase = 'uppercase'
}
